import React from 'react';
import Button from '../Button/Button';
import { colors } from '../../config/constants';

interface inputFormProps {
  isFormOpen: boolean;
  onSubmit: () => void;
  onCancel: any;
  title: string;
  children?: JSX.Element;
  ButtonText?: string;
  disabled?: boolean;
}

const InputForm = (props: inputFormProps) => {
  const { isFormOpen, onSubmit, onCancel, title, children, ButtonText, disabled } =
    props;

  return (
    <>
      {isFormOpen && (
        <div
          data-testid="inputform-wrapper"
          className={`flex flex-col px-1 md:px-4 py-3 mb-4 sm:my-2 transition-all duration-200 ease-in-out`}
        >
          <div className="flex items-center justify-center ">
            <div
              className={`w-full sm:w-3/4 rounded border border-[#e5e7eb] ${colors.primaryBorder} shadow-lg transition-all duration-200 ease-in-out`}
            >
              <div
                data-testid="inputform-title"
                className="text-lg mb-2 font-semibold bg-slate-200 text-[#0369a1] pl-2"
              >
                {title}
              </div>
              <div className="p-2">{children as JSX.Element}</div>
              <div className="flex  justify-center md:justify-end gap-4 mb-2 mr-2 transition-all duration-200 ease-in-out ">
                <Button
                  label={`${ButtonText ? ButtonText : 'submit'}`}
                  type={'button'}
                  buttonType={'primary'}
                  onClick={onSubmit}
                  disabled={disabled}
                />
                <Button
                  label={'cancel'}
                  type={'button'}
                  buttonType={'danger'}
                  onClick={onCancel}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InputForm;
